import { useState } from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Text,
  useToggle,
} from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import {
  TrainingRequestDetailFragment,
  TrainingRequestsEmployeeFragment,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

import EmployeeListItem from './EmployeeItem'

interface BlockProps {
  trainingRequest: TrainingRequestDetailFragment
  readonly: boolean
  form: FormikProps<UpdateData>
  employees: TrainingRequestsEmployeeFragment[]
}

export const ParticipantsBlock = ({ readonly, form, employees }: BlockProps) => {
  const [open, toggle] = useToggle()
  const [openSelector, setOpenSelector] = useState<boolean>(false)

  return (
    <>
      <CollapsableCard
        open={open}
        contentPadding="s24"
        Card={
          <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
            <Box gap="s8" flexDirection="row">
              <Text.Normal>
                {i18n.t('trainings.training_requests.create.employee_selector_step')}
              </Text.Normal>
              <Box
                borderRadius={{ all: 'abs006' }}
                background="grey400"
                paddingX="s8"
                paddingY="s2"
              >
                <Text size="200" color="grey1000" weight="medium">
                  {form.values.employeeIds.length}
                </Text>
              </Box>
            </Box>
            <Box gap="s16" flexDirection="row">
              <Button
                disabled={readonly}
                onClick={() => setOpenSelector(!openSelector)}
                iconName="pencil"
                type="secondary"
              ></Button>
              <Button
                onClick={toggle(!open)}
                iconName={`${open ? 'chevron-up' : 'chevron-down'}`}
                type="secondary"
              ></Button>
            </Box>
          </Box>
        }
        Content={
          <Box
            maxHeight="s300"
            borderRadius={{ all: 'abs016' }}
            background="grey000White"
            hideScrollBar
            overflowY="scroll"
            border={
              employees.length > 0 && { all: { color: 'grey400', width: 's1', style: 'solid' } }
            }
            flexDirection="column"
          >
            {employees
              .filter((x) => form.values.employeeIds.includes(x.id))
              .map((employee) => (
                <EmployeeListItem
                  employeeId={String(employee.id)}
                  employeeName={employee.fullName}
                  key={employee.id}
                  attachment={employee.avatar?.url ?? ''}
                ></EmployeeListItem>
              ))}
          </Box>
        }
      ></CollapsableCard>
      {openSelector && (
        <Modal
          title={i18n.t('trainings.training_requests.create.employee_selector_step')}
          onClose={() => setOpenSelector(false)}
        >
          <Selector.Container
            searchPlaceholder={i18n.t('common.search')}
            blankLabel=""
            value={form.values.employeeIds}
            // eslint-disable-next-line no-type-assertion/no-type-assertion
            onChange={(selection) =>
              form.setValues({ ...form.values, employeeIds: selection as number[] })
            }
            isMultiSelect
          >
            {employees.map((employee) => {
              return (
                <Selector.Option
                  key={employee.id}
                  value={employee.id}
                  label={employee.fullName}
                  searchValue={employee.fullName}
                >
                  {employee.fullName}
                </Selector.Option>
              )
            })}
          </Selector.Container>
        </Modal>
      )}
    </>
  )
}
